// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cookie-bar-position[data-v-48a57910] {
  position: absolute;
  left: 50%;
  bottom: 0px;
  transform: translate(-50%, -50%);
}
.slideFromBottom-enter[data-v-48a57910] {
  transform: translate(-50%, 100%);
}
.slideFromBottom-leave-to[data-v-48a57910] {
  transform: translate(-50%, 100%);
}
.slideFromBottom-enter-active[data-v-48a57910] {
  transition: transform 0.2s ease-out;
}
.slideFromBottom-leave-active[data-v-48a57910] {
  transition: transform 0.2s ease-in;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
